export default __webpack_public_path__ + "static/media/succulents.ff19d261.jpg";